<style lang="scss" scoped>
@import '$vars';

.medical-history-section {
  @apply flex flex-col items-center content-start justify-start;
  @apply w-full;
  margin-bottom: 2px;

  &__header {
    @apply flex flex-row items-center justify-between;
    @apply w-full p-2;
    @apply cursor-pointer;
    background: rgb(236, 240, 241);
  }

  &__title {
    @apply m-0 p-0;
    @apply text-grayDark;
    font-family: $font1;
    font-size: 0.8rem;
    font-weight: 600;
  }

  &__content {
    @apply w-full p-2;
  }

  &__icon {
    transition: all 0.3s ease;

    &--up {
      transform: rotate(180deg);
      transition: all 0.3s ease;
    }
  }
}
</style>

<template>
  <section class="medical-history-section">
    <header
      class="medical-history-section__header"
      @click="ui.isOpen = !ui.isOpen"
    >
      <h2 class="medical-history-section__title">
        Arquivos médicos
      </h2>

      <i
        :class="{ 'medical-history-section__icon--up': ui.isOpen }"
        class="icon icon-arrow-down medical-history-section__icon"
      />
    </header>

    <div
      v-if="ui.isOpen"
      ref="history-section-notes"
      class="medical-history-section__content"
    >
      <file-history
        type="file"
        :appointment-id="appointmentId"
      />
    </div>
  </section>
</template>

<script>
import FileHistory from '@/components/layout/appointments/fileHistory'

export default {
  name: 'MedicalHistoryFiles',

  components: {
    FileHistory
  },

  props: {
    appointmentId: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      ui: {
        isLoading: false,
        isOpen: false
      }
    }
  }
}
</script>
